import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'sonner';

export const useDeleteSeller = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sellerId) =>
      sellerServices.deleteSeller(sellerId),

    onSuccess: (data) => {
      toast.success(
        data?.message || 'Seller deleted successfully'
      );

      queryClient.invalidateQueries({
        queryKey: ['sellers'],
      });
    },

    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          'Failed to delete seller'
      );
    },
  });
};